import inici1 from '../../assets/images/inici_1.webp';
import inici1_400 from '../../assets/images/inici_1_400.webp';
import inici1_800 from '../../assets/images/inici_1_800.webp';
import inici1_1200 from '../../assets/images/inici_1_1200.webp';
import inici2 from '../../assets/images/inici_2.webp';
import inici2_400 from '../../assets/images/inici_2_400.webp';
import inici2_800 from '../../assets/images/inici_2_800.webp';
import inici2_1200 from '../../assets/images/inici_2_1200.webp';
import inici3 from '../../assets/images/inici_3.webp';
import inici3_400 from '../../assets/images/inici_3_400.webp';
import inici3_800 from '../../assets/images/inici_3_800.webp';
import inici3_1200 from '../../assets/images/inici_3_1200.webp';
import iniciWide from '../../assets/images/inici_wide.webp';
import iniciWide_600 from '../../assets/images/inici_wide_600.webp';
import iniciWide_1200 from '../../assets/images/inici_wide_1200.webp';
import iniciWide_2000 from '../../assets/images/inici_wide_2000.webp';
import logoImage from '../../assets/images/logo.png';
import titleDark from '../../assets/images/title_dark.svg';
import Avisos from '../Avis/Avisos';
import {
	Paragraph,
	SectionTitle,
	StandardContentContainer,
} from '../Shared/CommonStyles'; // Import shared styles

import * as S from './Inici.styles';

const Inici = () => {
	return (
		<StandardContentContainer>
			<Avisos /> {/* Added Avisos component */}
			{/* Logo and Big Title */}
			<S.HeaderSection>
				<S.StyledLogoImage
					src={logoImage}
					alt="AEiG Sant Narcís Logo"
				/>
				<S.StyledTitleImage
					src={titleDark}
					alt="AEiG Sant Narcís Títol"
				/>
			</S.HeaderSection>
			{/* Qui Som Section */}
			<S.Section>
				<SectionTitle>Qui som</SectionTitle>
				<Paragraph>
					Som l&apos;Agrupament Escolta i Guia de Sant Narcís, i
					formem part de l&apos;associació de Minyons Escoltes i Guies
					de Catalunya (MEG). Portem actius des del 1951 sent així el
					primer agrupament de la demarcació de Girona.
				</Paragraph>
				<Paragraph>
					Som una entitat d&apos;educació en el lleure que té com a
					objectiu educar infants i joves d&apos;entre 5 i 19 anys a
					través del mètode escolta i guia. Volem que creixin fent-los
					protagonistes del seu desenvolupament personal, per tal que
					esdevinguin persones actives, conscients i compromeses amb
					la societat on viuen, assumint les responsabilitats
					necessàries per ajudar a construir una societat més justa,
					solidària i sostenible.
				</Paragraph>
				<S.ThreeImageContainer>
					<S.ContentImage
						src={inici1}
						srcSet={`${inici1_400} 400w, ${inici1_800} 800w, ${inici1_1200} 1200w`}
						sizes="(max-width: 768px) calc(100vw - 30px), (max-width: 1100px) calc((100vw - 72px) / 3), 276px"
						alt="Imatge 1"
					/>
					<S.ContentImage
						src={inici2}
						srcSet={`${inici2_400} 400w, ${inici2_800} 800w, ${inici2_1200} 1200w`}
						sizes="(max-width: 768px) calc(100vw - 30px), (max-width: 1100px) calc((100vw - 72px) / 3), 276px"
						alt="Imatge 2"
					/>
					<S.ContentImage
						src={inici3}
						srcSet={`${inici3_400} 400w, ${inici3_800} 800w, ${inici3_1200} 1200w`}
						sizes="(max-width: 768px) calc(100vw - 30px), (max-width: 1100px) calc((100vw - 72px) / 3), 276px"
						alt="Imatge 3"
					/>
				</S.ThreeImageContainer>
			</S.Section>
			{/* Què Fem Section */}
			<S.Section>
				<SectionTitle>Què fem</SectionTitle>
				<Paragraph>
					Durant el curs ens trobem cada dissabte de 16h a 19h des de
					l&apos;octubre fins al juny als locals que tenim a la
					Carretera Sant Gregori a Girona. Cada mes i mig fem
					excursions de cap de setmana amb les unitats i també
					esporàdicament en fem amb tot l&apos;agrupament. A
					l&apos;estiu, per tancar el curs, fem una setmana de
					campaments i ruta amb les respectives unitats. Totes les
					sortides s&apos;acostumen a fer en un entorn natural per
					aprendre i gaudir de la natura i descobrir nous indrets de
					Catalunya.
				</Paragraph>
				<Paragraph>
					Eduquem a través del joc, dinàmiques, ponències, tallers i
					un ampli ventall d&apos;activitats pedagògiques, seguint els
					tres pilars de l&apos;escoltisme; persona, natura,
					espiritualitat; i lleis escoltes.
				</Paragraph>
				<S.WideContentImage
					src={iniciWide}
					srcSet={`${iniciWide_600} 600w, ${iniciWide_1200} 1200w, ${iniciWide_2000} 2000w`}
					sizes="(max-width: 768px) calc(100vw - 30px), (min-width: 901px) 860px, calc(100vw - 40px)"
					alt="Imatge Què fem"
				/>
			</S.Section>
			{/* Com Ens Organitzem Section */}
			<S.Section>
				<SectionTitle>Com ens organitzem</SectionTitle>
				<Paragraph>
					El cau està format pels infants i joves, els caps i les
					famílies. Dividim els infants i joves per grups d&apos;edat
					que anomenem unitats.
				</Paragraph>
				<Paragraph>
					<strong>Unitat de Castors i Llúdrigues</strong>
					<br />
					Riu amunt
					<br />6 - 8 anys
				</Paragraph>
				<Paragraph>
					<strong>Unitat de Llops i Daines</strong>
					<br />
					Tant com puc
					<br />8 - 11 anys
				</Paragraph>
				<Paragraph>
					<strong>Unitat de Ràngers i Noies Guia</strong>
					<br />
					Sempre a punt
					<br />
					11-14 anys
				</Paragraph>
				<Paragraph>
					<strong>Unitat de Pioners i Caravel·les</strong>
					<br />
					Fent camí
					<br />
					14-17 anys
				</Paragraph>
				<Paragraph>
					<strong>Unitat de Trucs</strong>
					<br />
					Fent servei
					<br />
					17-19 anys
				</Paragraph>
				<Paragraph>
					<strong>Caps</strong>
					<br />
					Els caps som un grup de joves voluntaris que ens organitzem
					per oferir una educació en el lleure de qualitat. Treballem
					en equip per preparar i acompanyar les activitats de cada
					unitat i som els responsables del funcionament de
					l&apos;agrupament.
				</Paragraph>
			</S.Section>
		</StandardContentContainer>
	);
};

export default Inici;
